import loadable from '@loadable/component';

import { handleChunkLoadError } from '../../utils/loadable';
import type { IUpcomingSalePopupContainerProps } from './UpcomingSalePopupContainer';

export const UpcomingSalePopupContainerLoadable = loadable(() => {
  if (process.env.IS_BROWSER_BUILD) {
    return import('./UpcomingSalePopupContainer').catch(
      /* istanbul ignore next */ handleChunkLoadError<IUpcomingSalePopupContainerProps>('UpcomingSalePopupContainer'),
    );
  }

  return Promise.resolve({
    default: () => null,
  });
});
